import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import { DialogForm } from '../DialogForm';
import AddUserFormDataConfig, { userTypeConfig } from './tenantUserFormDataConfig';
import { ADD_TENANT_USER, FETCH_USER_ROLE } from '../../containers/graphQL/queries';

const useStyles = makeStyles(theme => ({
  dialog: {
    width: '100%'
  },
  dialogTitle: {
    padding: theme.spacing(2),
    borderBottom: '1px solid'
  },
  progress: {
    color: theme.palette.background.paper
  },
  textField: {
    width: '80%'
  },
  grid: {
    width: '100%',
    borderBottom: '1px solid #EBEBEB'
  },
  headers: {
    color: theme.palette.text.secondary
  }
}));

interface AddUserDialog {
  handleDialogOpen?: any;
  handledialogclose?: any;
  edit?: true | false;
  formData?: any;
  handleDialogSubmit?: any;
  formInfo?: any;
  refresh?: any;
  participantCode?: any;
  dialogOpen?: true | false;
  usersData?: any;
}

let dataConfig = [...AddUserFormDataConfig];

const AddTenantUserDialog = (props: AddUserDialog) => {
  const [addUser] = useMutation(ADD_TENANT_USER);
  const [loader, setLoader] = useState(false);
  const [fetchUserRole] = useMutation(FETCH_USER_ROLE);
  const [formValidated, setFormValidated] = useState(false);
  const [formError, setFormError] = useState(false);
  const [formErrorMsg, setFormErrorMsg] = useState('');
  // const [getUserRole] = useMutation(ADD_USER);
  const classes = useStyles();
  const { edit, formData, usersData } = props;
  const [formInfo, setFormInfo] = React.useState<any>({});

  const { enqueueSnackbar } = useSnackbar();
  let { participantCode } = props;

  useEffect(() => {
    if (props.edit) {
      setFormError(false);
      setFormErrorMsg('');
      const editData: any[] = [];
      let roleObj: { [x: string]: any } = {};
      let role =
        formData &&
        formData.tenantRoles &&
        formData.tenantRoles.length &&
        formData.tenantRoles[0] &&
        formData.tenantRoles[0].roleType;
      roleObj['userType'] = role;
      setFormInfo({ ...formData, ...roleObj });
      (dataConfig || []).forEach((obj: any) => {
        let temp = { ...obj };
        if (temp.key === 'userName') {
          temp.disabled = true;
        }
        editData.push(temp);
      });
      dataConfig = [...editData];
    } else {
      setFormInfo({
        ...props.formInfo
      });
    }
  }, [formData, edit, props.formInfo]);

  const submitUserData = (formDataObj: any) => {
    props.handleDialogSubmit();
    addUser({
      variables: {
        userName: formDataObj.userName,
        firstName: formDataObj.firstName,
        lastName: formDataObj.lastName,
        userType: formDataObj?.userType,
        status: 'ACTIVE',
        method: 'POST',
        participantCode: participantCode
      }
    })
      .then(response1 => {
        enqueueSnackbar(edit ? 'Modified User Details successfully !!' : 'Added User successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        props.refresh();
        return response1;
      })
      .catch(() => {
        enqueueSnackbar(edit ? 'Modified User Details failed' : 'Add User failed !!', {
          variant: 'error',
          preventDuplicate: true
        });
        if (edit) {
          props.refresh();
        }
      });
  };

  const validateUser = (formDataObj: any) => {
    if (formDataObj?.userName !== undefined) {
      let userName = formDataObj.userName;
      let filteredUsers = usersData?.length && usersData.filter((item: any) => item.userName === userName);
      setLoader(true);
      if (filteredUsers && filteredUsers.length >= 1) {
        setFormValidated(false);
        setFormError(true);
        setFormErrorMsg('User Already Exist');
        setLoader(false);
      } else {
        setLoader(false);
        setFormError(false);
        setFormValidated(true);
        submitUserData(formDataObj);
      }
      const editData: any[] = [];
      (dataConfig || []).forEach((obj: any) => {
        let temp = { ...obj };
        temp.defaultValue = formDataObj && formDataObj[temp.key];
        editData.push(temp);
      });
      dataConfig = [...editData];
    }
  };

  const getLatestValues = (dataObj: any) => {
    dataObj.parameters = [];
    const editData: any[] = [];
    (dataConfig || []).forEach((obj: any) => {
      let temp = { ...obj };
      if (temp.key === 'userType') {
        temp.defaultValue = dataObj?.userType;
      }
      editData.push(temp);
    });
    dataConfig = [...editData];
    setFormInfo(dataObj);
  };

  return (
    <React.Fragment>
      <DialogForm
        key={edit ? 'edit-user-dialog' : 'new-user-dialog'}
        openFn={props.dialogOpen}
        closeFn={props.handledialogclose}
        dataConfig={edit ? dataConfig : [...AddUserFormDataConfig]}
        handleDialogClose={props.handledialogclose}
        handleDialogSubmit={edit ? submitUserData : validateUser}
        submitlabel="Submit"
        dialogId={'new-user-dialog'}
        title={edit ? 'Edit User Details' : 'Create User'}
        data={formInfo}
        getLatestValues={getLatestValues}
        loading={loader}
        formErrorMsg={formErrorMsg}
        formError={formError}
      ></DialogForm>
    </React.Fragment>
  );
};

export default AddTenantUserDialog;
